import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {webSocket, WebSocketSubject} from 'rxjs/webSocket';
import {BehaviorSubject, filter, timer} from 'rxjs';
import {environment} from '../../environments/environment';
import {UTMService} from './utm.service';
import {TrackerService} from './tracker.service';
import {TrackingService} from './tracking.service';

@Injectable({
  providedIn: 'root'
})
export class ChatSocketService {
  public messages$: BehaviorSubject<any[]> = new BehaviorSubject([] as any[]);
  public entities$: BehaviorSubject<{ [key: string]: string }> = new BehaviorSubject({});
  public entities_v2$: BehaviorSubject<{ [key: string]: string }> = new BehaviorSubject({});
  public typing$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  subscription: any;
  private socket$?: WebSocketSubject<any>;
  private conversationId?: string;
  private isFakeTyping$ = new BehaviorSubject<boolean>(false);

  // public connect() {
  //   console.log(this.socket$, this.socket$?.closed);
  //   let uid = localStorage.getItem('conv_uid');
  //   if (!this.socket$ || this.socket$.closed) {
  //     let params: {[key: string]: any} = {}
  //     if (uid) {
  //       params['uid'] = uid;
  //     }
  //     console.log('INITIALIZE', params);
  //     return this.httpClient.get(`${environment.botApi}/initialize`, {params})
  //       .pipe(switchMap((data: any) => {
  //         this.conversationId = data.id;
  //         localStorage.setItem('conv_uid', data.id);
  //         data.messages.forEach((message: any) => {
  //           if (message.with_psychics) {
  //             message.psychics = data.psychics;
  //           }
  //         });
  //         this.messages$.next(data.messages);
  //         this.entities$.next(data.entities);
  //         this.createSocket();
  //         return of(null);
  //       }));
  //   }
  //   return of(null);
  // }
  //
  // sendMessage(message: string) {
  //   this.messages$.next(this.messages$.value.concat({role: 'user', type: "message", content: message}));
  //   this.socket$?.next({message, type: "message"});
  // }
  //
  // sendCards(cards: [number, number, number]) {
  //   // this.messages$.next(this.messages$.value.concat({role: 'user', content: message}));
  //   this.socket$?.next({cards, type: "cards"});
  // }
  //
  // subscription: any;
  //
  // close() {
  //   console.log('CLOSE');
  //   this.socket$?.unsubscribe();
  // }
  //
  // private createSocket() {
  //   console.log('create socket');
  //   this.socket$ = webSocket({url: `${environment.botWebsocket}?uid=${this.conversationId}`});
  //   this.subscription = this.socket$.subscribe({
  //     next: data => {
  //       console.log(data);
  //       switch (data.type) {
  //         case 'show_cards':
  //           break;
  //         case 'message':
  //         case 'message+show_cards':
  //           delete data.type;
  //           if (data.entities) {
  //             this.entities$.next(data.entities);
  //           }
  //           this.messages$.next(this.messages$.value.concat(data.message));
  //           this.typing$.next(false);
  //
  //           break;
  //         case 'typing':
  //           this.typing$.next(true);
  //       }
  //     }, complete: () => {
  //       console.log('SOCKET COMPLETE', this.socket$?.closed);
  //     }
  //   });
  //   console.log('end create socket');
  // }
  // public connect() {
  //   let uid = localStorage.getItem('conv_uid');
  //   if (!this.socket$ || this.socket$.closed) {
  //     let params: {[key: string]: any} = {}
  //     if (uid) {
  //       params['uid'] = uid;
  //     }
  //     return this.httpClient.get(`${environment.botApi}/initialize`, {params})
  //       .pipe(switchMap((data: any) => {
  //         this.conversationId = data.id;
  //         localStorage.setItem('conv_uid', data.id);
  //         data.messages.forEach((message: any) => {
  //           if (message.with_psychics) {
  //             message.psychics = data.psychics;
  //           }
  //         });
  //         this.messages$.next(data.messages);
  //         this.entities$.next(data.entities);
  //         this.createSocket();
  //         return of(null);
  //       }));
  //   }
  //   return of(null);
  // }

  constructor(@Inject(LOCALE_ID) private locale: string,
              private utmService: UTMService,
              private trackerService: TrackerService,
              private trackingService: TrackingService) {
    this.locale = this.locale === 'fr-x-source' ? 'fr-FR' : this.locale;
  }

  sendMessage(message: string) {
    const isFirstMessage = !this.messages$.value.find(v => v.role === 'human');
    if (isFirstMessage) {
      this.trackingService.gameEvent('FirstAnswer');
    }
    const tempId = "id" + Math.random().toString(16).slice(2);
    this.messages$.next(this.messages$.value.concat({
      role: 'human',
      type: "text",
      content: message,
      tempId,
      timestamp: Date.now()
    }));
    this.socket$?.next({role: 'human', content: message, type: "text", tempId});
  }

  sendCards(cards: [number, number, number]) {
    // this.messages$.next(this.messages$.value.concat({role: 'user', content: message}));
    this.socket$?.next({content: cards, type: "cards", role: "human"});
  }

  close() {
    this.socket$?.unsubscribe();
  }

  createSocket() {
    console.log('!!! createSocket() called');
    this.conversationId = this.getUid();
    const url = new URL(`${environment.botWebsocket}?uid=${this.conversationId}&locale=${this.locale}`);
    const utmList = this.utmService.getCurrentUtmList(this.utmService.getDefaultUtmList());
    if (utmList) {
      const UTMs = this.utmService.urlFormat(utmList);
      for (const [k, v] of Object.entries(UTMs)) {
        url.searchParams.set(k, v);
      }
    }
    const trackerData = this.trackerService.getCurrentTrackerData(this.trackerService.getDefaultTrackerData());
    if (trackerData) {
      const trackers = this.trackerService.urlFormat(trackerData);
      for (const [k, v] of Object.entries(trackers)) {
        url.searchParams.set(k, v);
      }
    }

    this.socket$ = webSocket({
      url: url.toString(),
      closeObserver: {
        next: (closeEvent) => {
          console.log('Close event:', closeEvent.code);
          if (closeEvent.code !== 1008) {
            console.log('=> call create socket');
            this.createSocket();
          }
        }
      },
    });
    this.subscription = this.socket$.subscribe({
      next: data => {
        if (data.action && data.action === 'retry') {
          this.conversationId = data.args.uuid;
          this.persistUid(data.args.uuid);
          console.log('!!! Socket receive "retry", so unsubscribe and createSocket()');
          this.socket$?.unsubscribe();
          this.createSocket();
          return;
        }

        if (data.entities) {
          if (Object.keys(this.entities$.value).length > 0 && !this.entities$.value['name'] && data.entities['name']) {
            console.log('Got name');
            this.trackingService.gameEvent('GetName');
          }
          if (Object.keys(this.entities$.value).length > 0 && !this.entities$.value['email'] && data.entities['email']) {
            console.log('Got email');
            this.trackingService.gameEvent('GetEmail');
          }
          if (Object.keys(this.entities$.value).length > 0 && !this.entities$.value['birthdate'] && data.entities['birthdate']) {
            console.log('Got birthdate');
            this.trackingService.gameEvent('GetBirthDate');
          }
          this.entities$.next(data.entities);
        }
        data.messages.forEach((message: any) => {
          switch (message.type) {
            case 'text':
            case 'cards':
              this.isFakeTyping$.pipe(filter(v => !v)).subscribe(() => {
                if (message.experts && message.experts.length > 0) {
                  this.trackingService.gameEvent('ExpertsList', {
                    experts: message.experts.map(({id, title}: {
                      id: number,
                      title: string
                    }) => ({id, title}))
                  });
                }

                if (message.tempId) {
                  const index = this.messages$.value.findIndex(v => v.tempId === message.tempId);
                  if (index !== -1) {
                    // Create a copy of the found object to avoid direct mutation + extract tempId from the message
                    // @ts-ignore
                    const {tempId, ...updatedMessage} = {...this.messages$.value[index], ...message};
                    // Update the array with the modified message
                    this.messages$.next([
                      ...this.messages$.value.slice(0, index),
                      updatedMessage,
                      ...this.messages$.value.slice(index + 1)
                    ]);
                  }
                }
                if (!this.messages$.value.find(v => v.timestamp === message.timestamp)) {
                  const {tempId, ...newMessage} = message;
                  this.messages$.next(this.messages$.value.concat(newMessage));
                  this.typing$.next(false);
                }
              });
              break;
            case 'entities_alternative':
              this.entities_v2$.next(message.entities);
              break;
            case 'typing':
              this.typing$.next(true);
              this.isFakeTyping$.next(true);
              timer(3000).subscribe(() => {
                this.isFakeTyping$.next(false);
              });
          }
        })
      },
      error: (error) => {
        console.log('!!! Socket error', error); // , wait 3s and call a createSocket'
        // setTimeout(() => {
        //   this.createSocket();
        // }, 3000);
      },
      complete: () => {
        if (!this.socket$?.closed) {
          // when the server close
          console.log('!!! Socket complete but not "closed"'); // , call a createSocket
          // console.log(this.socket$);
          // this.createSocket();
        } else {
          // when the client close
          console.log('!!! Socket complete and closed'); // , do nothing
        }
      }
    });
  }

  persistUid(uid: string) {
    let data = JSON.parse(localStorage.getItem('conv') ?? '{}');
    data[this.locale] = uid;
    localStorage.setItem('conv', JSON.stringify(data));
  }

  getUid(): string | undefined {
    let data = JSON.parse(localStorage.getItem('conv') ?? '{}');
    return data[this.locale];
  }

  removeUid() {
    let data = JSON.parse(localStorage.getItem('conv') ?? '{}');
    delete data[this.locale];
    localStorage.setItem('conv', JSON.stringify(data));
  }
}
